import { createSlice } from '@reduxjs/toolkit';

const initialUserType = {
    isAdmin:null,
    isProviderAdmin:null,
    isSuperAdmin:null,
};

const userTypeSlice = createSlice({
    name: 'userType',
    initialState: initialUserType,
    reducers: {
        setUserType: (state, action) => {
            const { isAdmin, isSuperAdmin, isProviderAdmin } = action.payload;
            state.isAdmin = isAdmin;
            state.isProviderAdmin = isProviderAdmin;
            state.isSuperAdmin = isSuperAdmin;
        },
        resetUserType: (state, action) => {
            state.isAdmin=false;
            state.isProviderAdmin=false;
            state.isSuperAdmin=false;
        },
    }
});

export const {
    setUserType,
    resetUserType,
} = userTypeSlice.actions;

export default userTypeSlice.reducer;
